module.exports = __webpack_public_path__ + "static/media/envelope-open.947f75f1.svg";